module.exports = __webpack_public_path__ + "img/collegues-second.bc443357.png";